import React from "react";

import { NavLink } from "react-router-dom";

import type { JSX } from "react";

interface DataTableLinkCellProps {
  href: string | undefined;
  children: string;
}

export const LINK_CELL_CLASS =
  "focus-visible:ring-ring/50 truncate rounded-sm outline-none focus-visible:ring-[3px]";

function DataTableLinkCell({
  href,
  children,
}: DataTableLinkCellProps): JSX.Element | null {
  if (!children) return null;

  return href ? (
    <NavLink className={LINK_CELL_CLASS} title={children} to={href}>
      {children}
    </NavLink>
  ) : (
    <span className="truncate" title={children}>
      {children}
    </span>
  );
}

export default DataTableLinkCell;
